<a mat-list-item [ngStyle]="{ 'padding-left': depth * 12 + 'px' }" (click)="onItemSelected(item)"
  [ngClass]="{ active: item.route ? router.isActive(item.route, false) : false, expanded: expanded }"
  class="menu-list-item">
  <span *ngIf="item.route ? router.isActive(item.route, false) : false; else elseBlock">
    <mat-icon class="routeIcon">{{ item.iconName }}</mat-icon>
  </span>
  <ng-template #elseBlock>
    <mat-icon class="routeIcon">{{ item.iconName }}</mat-icon>
  </ng-template>
  {{ item.displayName }}

  <span *ngIf="this.PRCount && item.displayName == 'PR Approval'" class="counter-badge">
    {{ PRCount }}
  </span>
  <span *ngIf="this.resourceCount && item.displayName == 'Resource Approval'" class="counter-badge">
    {{ resourceCount }}
  </span>

  <span fxFlex *ngIf="item.children && item.children.length">
    <span fxFlex></span>
    <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'"> expand_more </mat-icon>
  </span>
</a>

<div *ngIf="expanded">
  <app-menu-list-item *ngFor="let child of item.children" [item]="child" [depth]="depth + 1"></app-menu-list-item>
</div>